var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('sidebar.newDoc') || 'Nuevo documento',"title":_vm.$t('sidebar.newDoc') || 'Nuevo documento',"id":"new-doc-button"},on:{"click":_vm.newDoc}},[_c('file-text-icon',{staticClass:"custom-class",attrs:{"size":"1.5x"}}),_c('span',[_vm._v(_vm._s(_vm.$t('sidebar.newDoc') || 'Documento'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }